/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { startsWith } from 'lodash';
import { Field } from 'react-final-form';
import { Text } from '@blend/enterprise-components';

import { forgotPassword } from 'id-api/auth';
import { FormCard } from 'id-components/FormCard';
import { usernameInputConfig } from 'id-constants/commonInputs';
import { extractValue, useLoginFlowSubmit } from 'id-utils/login';

export namespace ForgotPasswordPage {
  export interface Props {}
}

export const ForgotPasswordPage: React.FC<ForgotPasswordPage.Props> = ({}) => {
  const onSubmit = useLoginFlowSubmit(forgotPassword);

  const usernameFromParams = (() => {
    const qs = window.location.search.slice(1);
    if (!startsWith(qs, 'username')) return undefined;
    return extractValue(decodeURIComponent(qs));
  })();

  return (
    <FormCard<Identity.API.ResetPasswordBody>
      headerLabel={
        <Text>
          Enter your email below and Blend will send you an email to reset your password. Follow the instructions on the
          next screen to complete the process.
        </Text>
      }
      headerTitle="Forgot your Password?"
      id="it-ForgotPassword"
      onSubmit={onSubmit}
      submitLabel="Reset my password"
    >
      <Field {...usernameInputConfig} initialValue={usernameFromParams} />
    </FormCard>
  );
};
